import { CurrencyType } from '@dealstack/shared/lib/generated';

const CURRENCIES = [
	{
		name: 'Euro',
		code: 'EUR',
		group: 'Frequently used',
	},
	{
		name: 'Pound Sterling',
		code: 'GBP',
		group: 'Frequently used',
	},
	{
		name: 'US Dollar',
		code: 'USD',
		group: 'Frequently used',
	},
	{
		name: 'Canadian Dollar',
		code: 'CAD',
		group: 'Frequently used',
	},
	{
		name: 'Swiss Franc',
		code: 'CHF',
		group: 'Frequently used',
	},
	{
		name: 'Danish Krone',
		code: 'DKK',
		group: 'Frequently used',
	},
	{
		name: 'Norwegian Krone',
		code: 'NOK',
		group: 'Frequently used',
	},
	{
		name: 'Swedish Krona',
		code: 'SEK',
		group: 'Frequently used',
	},
	{
		name: 'Algerian Dinar',
		code: 'DZD',
	},
	{
		name: 'Argentine Peso',
		code: 'ARS',
	},
	{
		name: 'Armenian Dram',
		code: 'AMD',
	},
	{
		name: 'Aruban Florin',
		code: 'AWG',
	},
	{
		name: 'Australian Dollar',
		code: 'AUD',
	},
	{
		name: 'Azerbaijan Manat',
		code: 'AZN',
	},
	{
		name: 'Bahamian Dollar',
		code: 'BSD',
	},
	{
		name: 'Bahraini Dinar',
		code: 'BHD',
	},
	{
		name: 'Baht',
		code: 'THB',
	},
	{
		name: 'Balboa',
		code: 'PAB',
	},
	{
		name: 'Barbados Dollar',
		code: 'BBD',
	},
	{
		name: 'Belarusian Ruble',
		code: 'BYN',
	},
	{
		name: 'Belize Dollar',
		code: 'BZD',
	},
	{
		name: 'Bermudian Dollar',
		code: 'BMD',
	},
	{
		name: 'Bolívar Soberano',
		code: 'VES',
	},
	{
		name: 'Bolívar Soberano',
		code: 'VED',
	},
	{
		name: 'Boliviano',
		code: 'BOB',
	},
	{
		name: 'Brazilian Real',
		code: 'BRL',
	},
	{
		name: 'Brunei Dollar',
		code: 'BND',
	},
	{
		name: 'Bulgarian Lev',
		code: 'BGN',
	},
	{
		name: 'Burundi Franc',
		code: 'BIF',
	},
	{
		name: 'Cabo Verde Escudo',
		code: 'CVE',
	},
	{
		name: 'Cayman Islands Dollar',
		code: 'KYD',
	},
	{
		name: 'CFA Franc BCEAO',
		code: 'XOF',
	},
	{
		name: 'CFA Franc BEAC',
		code: 'XAF',
	},
	{
		name: 'CFP Franc',
		code: 'XPF',
	},
	{
		name: 'Chilean Peso',
		code: 'CLP',
	},
	{
		name: 'Colombian Peso',
		code: 'COP',
	},
	{
		name: 'Comorian Franc ',
		code: 'KMF',
	},
	{
		name: 'Congolese Franc',
		code: 'CDF',
	},
	{
		name: 'Convertible Mark',
		code: 'BAM',
	},
	{
		name: 'Cordoba Oro',
		code: 'NIO',
	},
	{
		name: 'Costa Rican Colon',
		code: 'CRC',
	},
	{
		name: 'Cuban Peso',
		code: 'CUP',
	},
	{
		name: 'Czech Koruna',
		code: 'CZK',
	},
	{
		name: 'Dalasi',
		code: 'GMD',
	},
	{
		name: 'Denar',
		code: 'MKD',
	},
	{
		name: 'Djibouti Franc',
		code: 'DJF',
	},
	{
		name: 'Dobra',
		code: 'STN',
	},
	{
		name: 'Dominican Peso',
		code: 'DOP',
	},
	{
		name: 'Dong',
		code: 'VND',
	},
	{
		name: 'East Caribbean Dollar',
		code: 'XCD',
	},
	{
		name: 'Egyptian Pound',
		code: 'EGP',
	},
	{
		name: 'El Salvador Colon',
		code: 'SVC',
	},
	{
		name: 'Ethiopian Birr',
		code: 'ETB',
	},
	{
		name: 'Falkland Islands Pound',
		code: 'FKP',
	},
	{
		name: 'Fiji Dollar',
		code: 'FJD',
	},
	{
		name: 'Forint',
		code: 'HUF',
	},
	{
		name: 'Ghana Cedi',
		code: 'GHS',
	},
	{
		name: 'Gibraltar Pound',
		code: 'GIP',
	},
	{
		name: 'Gourde',
		code: 'HTG',
	},
	{
		name: 'Guarani',
		code: 'PYG',
	},
	{
		name: 'Guinean Franc',
		code: 'GNF',
	},
	{
		name: 'Guyana Dollar',
		code: 'GYD',
	},
	{
		name: 'Hong Kong Dollar',
		code: 'HKD',
	},
	{
		name: 'Hryvnia',
		code: 'UAH',
	},
	{
		name: 'Iceland Krona',
		code: 'ISK',
	},
	{
		name: 'Indian Rupee',
		code: 'INR',
	},
	{
		name: 'Iranian Rial',
		code: 'IRR',
	},
	{
		name: 'Iraqi Dinar',
		code: 'IQD',
	},
	{
		name: 'Jamaican Dollar',
		code: 'JMD',
	},
	{
		name: 'Jordanian Dinar',
		code: 'JOD',
	},
	{
		name: 'Kenyan Shilling',
		code: 'KES',
	},
	{
		name: 'Kina',
		code: 'PGK',
	},
	{
		name: 'Kuwaiti Dinar',
		code: 'KWD',
	},
	{
		name: 'Kwanza',
		code: 'AOA',
	},
	{
		name: 'Kyat',
		code: 'MMK',
	},
	{
		name: 'Lao Kip',
		code: 'LAK',
	},
	{
		name: 'Lari',
		code: 'GEL',
	},
	{
		name: 'Lebanese Pound',
		code: 'LBP',
	},
	{
		name: 'Lek',
		code: 'ALL',
	},
	{
		name: 'Lempira',
		code: 'HNL',
	},
	{
		name: 'Leone',
		code: 'SLE',
	},
	{
		name: 'Liberian Dollar',
		code: 'LRD',
	},
	{
		name: 'Libyan Dinar',
		code: 'LYD',
	},
	{
		name: 'Lilangeni',
		code: 'SZL',
	},
	{
		name: 'Loti',
		code: 'LSL',
	},
	{
		name: 'Malagasy Ariary',
		code: 'MGA',
	},
	{
		name: 'Malawi Kwacha',
		code: 'MWK',
	},
	{
		name: 'Malaysian Ringgit',
		code: 'MYR',
	},
	{
		name: 'Mauritius Rupee',
		code: 'MUR',
	},
	{
		name: 'Mexican Peso',
		code: 'MXN',
	},
	{
		name: 'Moldovan Leu',
		code: 'MDL',
	},
	{
		name: 'Moroccan Dirham',
		code: 'MAD',
	},
	{
		name: 'Mozambique Metical',
		code: 'MZN',
	},
	{
		name: 'Naira',
		code: 'NGN',
	},
	{
		name: 'Nakfa',
		code: 'ERN',
	},
	{
		name: 'Namibia Dollar',
		code: 'NAD',
	},
	{
		name: 'Nepalese Rupee',
		code: 'NPR',
	},
	{
		name: 'Netherlands Antillean Guilder',
		code: 'ANG',
	},
	{
		name: 'New Israeli Sheqel',
		code: 'ILS',
	},
	{
		name: 'New Taiwan Dollar',
		code: 'TWD',
	},
	{
		name: 'New Zealand Dollar',
		code: 'NZD',
	},
	{
		name: 'Ngultrum',
		code: 'BTN',
	},
	{
		name: 'North Korean Won',
		code: 'KPW',
	},
	{
		name: 'Ouguiya',
		code: 'MRU',
	},
	{
		name: 'Pa’anga',
		code: 'TOP',
	},
	{
		name: 'Pakistan Rupee',
		code: 'PKR',
	},
	{
		name: 'Pataca',
		code: 'MOP',
	},
	{
		name: 'Peso Convertible',
		code: 'CUC',
	},
	{
		name: 'Peso Uruguayo',
		code: 'UYU',
	},
	{
		name: 'Philippine Peso',
		code: 'PHP',
	},
	{
		name: 'Pula',
		code: 'BWP',
	},
	{
		name: 'Qatari Rial',
		code: 'QAR',
	},
	{
		name: 'Quetzal',
		code: 'GTQ',
	},
	{
		name: 'Rand',
		code: 'ZAR',
	},
	{
		name: 'Rial Omani',
		code: 'OMR',
	},
	{
		name: 'Riel',
		code: 'KHR',
	},
	{
		name: 'Romanian Leu',
		code: 'RON',
	},
	{
		name: 'Rufiyaa',
		code: 'MVR',
	},
	{
		name: 'Rupiah',
		code: 'IDR',
	},
	{
		name: 'Russian Ruble',
		code: 'RUB',
	},
	{
		name: 'Rwanda Franc',
		code: 'RWF',
	},
	{
		name: 'Saint Helena Pound',
		code: 'SHP',
	},
	{
		name: 'Saudi Riyal',
		code: 'SAR',
	},
	{
		name: 'Serbian Dinar',
		code: 'RSD',
	},
	{
		name: 'Seychelles Rupee',
		code: 'SCR',
	},
	{
		name: 'Singapore Dollar',
		code: 'SGD',
	},
	{
		name: 'Sol',
		code: 'PEN',
	},
	{
		name: 'Solomon Islands Dollar',
		code: 'SBD',
	},
	{
		name: 'Som',
		code: 'KGS',
	},
	{
		name: 'Somali Shilling',
		code: 'SOS',
	},
	{
		name: 'Somoni',
		code: 'TJS',
	},
	{
		name: 'South Sudanese Pound',
		code: 'SSP',
	},
	{
		name: 'Sri Lanka Rupee',
		code: 'LKR',
	},
	{
		name: 'Sucre',
		code: 'XSU',
	},
	{
		name: 'Sudanese Pound',
		code: 'SDG',
	},
	{
		name: 'Surinam Dollar',
		code: 'SRD',
	},
	{
		name: 'Syrian Pound',
		code: 'SYP',
	},
	{
		name: 'Taka',
		code: 'BDT',
	},
	{
		name: 'Tala',
		code: 'WST',
	},
	{
		name: 'Tanzanian Shilling',
		code: 'TZS',
	},
	{
		name: 'Tenge',
		code: 'KZT',
	},
	{
		name: 'Trinidad and Tobago Dollar',
		code: 'TTD',
	},
	{
		name: 'Tugrik',
		code: 'MNT',
	},
	{
		name: 'Tunisian Dinar',
		code: 'TND',
	},
	{
		name: 'Turkish Lira',
		code: 'TRY',
	},
	{
		name: 'Turkmenistan New Manat',
		code: 'TMT',
	},
	{
		name: 'UAE Dirham',
		code: 'AED',
	},
	{
		name: 'Uganda Shilling',
		code: 'UGX',
	},
	{
		name: 'Uzbekistan Sum',
		code: 'UZS',
	},
	{
		name: 'Vatu',
		code: 'VUV',
	},
	{
		name: 'Won',
		code: 'KRW',
	},
	{
		name: 'Yemeni Rial',
		code: 'YER',
	},
	{
		name: 'Yen',
		code: 'JPY',
	},
	{
		name: 'Yuan Renminbi',
		code: 'CNY',
	},
	{
		name: 'Zambian Kwacha',
		code: 'ZMW',
	},
	{
		name: 'Zimbabwe Dollar',
		code: 'ZWL',
	},
	{
		name: 'Zloty',
		code: 'PLN',
	},
];

const FREQUENTLY_USED_CURRENCY_GROUP = 'Frequently used';

const toCurrencyOption = (currency: { name: string; code: string }) => ({
	value: currency.code,
	label: `${currency.name} (${currency.code})`,
});

// Flat `{ value, label }` variant for consumers that map/filter the list (table
// filters); plain `<Select>` consumers use CURRENCIES_GROUPED_OPTIONS to keep the
// v6 "Frequently used" group. A bare `group` key on a flat item white-screens v7,
// so grouping uses the nested `{ group, items }` shape below.
export const CURRENCIES_OPTIONS = CURRENCIES.map(toCurrencyOption);

const buildGroupedCurrencyOptions = (
	predicate: (currency: { code: string }) => boolean = () => true
) => {
	const filtered = CURRENCIES.filter(predicate);
	const frequent = filtered
		.filter((currency) => currency.group === FREQUENTLY_USED_CURRENCY_GROUP)
		.map(toCurrencyOption);
	const rest = filtered
		.filter((currency) => currency.group !== FREQUENTLY_USED_CURRENCY_GROUP)
		.map(toCurrencyOption);
	return [
		...(frequent.length ? [{ group: FREQUENTLY_USED_CURRENCY_GROUP, items: frequent }] : []),
		...rest,
	];
};

export const CURRENCIES_GROUPED_OPTIONS = buildGroupedCurrencyOptions();

export const getCurrenciesGroupedOptionsExcluding = (excludeCode?: string | null) =>
	buildGroupedCurrencyOptions((currency) => currency.code !== excludeCode);

export const getCurrencyFullNameByCode = (code: CurrencyType): string | null => {
	const currency = CURRENCIES.find((currency) => currency.code === code);
	if (!currency) {
		return null;
	}
	return `${currency.name} (${currency.code})`;
};
